var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"footer"},[_c('span',{on:{"click":_vm.goBeian}},[_vm._v("闽ICP备19006430号-2")])])])}
var staticRenderFns = []

export { render, staticRenderFns }